import { ActionButton, Dialog } from "@eisox/design-system";
import { ArrowRightIcon, WarningIcon } from "@eisox/icons";
import { colors } from "@eisox/tokens";

import { m } from "~/paraglide/messages";

interface ModificationDialogProps {
  onClickContinue: VoidFunction;
  open: boolean;
  onClose: VoidFunction;
}

const ModificationDialog: React.FC<ModificationDialogProps> = ({ onClickContinue, open, onClose }) => (
  <Dialog.Root open={open} onOpenChange={open => !open && onClose()}>
    <Dialog.Content
      icon={<WarningIcon color={colors.primary.red} className="h-[33px] w-[33px] text-primary-red" />}
      title={m.updates_not_saved()}
    >
      <div className="mt-10 flex items-center justify-center gap-x-[10px]">
        <ActionButton variant="cancel" onClick={() => onClose()}>
          {m.cancel_updates()}
        </ActionButton>
        <ActionButton variant="danger" onClick={() => onClickContinue()}>
          {m.continue_updates()}
          <ArrowRightIcon />
        </ActionButton>
      </div>
    </Dialog.Content>
  </Dialog.Root>
);

ModificationDialog.displayName = "ModificationDialog";

export { ModificationDialog };
export type { ModificationDialogProps };
